import { useSuspenseQuery } from '@tanstack/react-query';

import { BANNER_CONTENTS_TYPE, UnauthQueryOptions } from '@/api';
import { useWebviewTypeEntry } from '@/hooks/useWebviewTypeEntry';

export const useTopBanner = () => {
  const { entry } = useWebviewTypeEntry();

  const { data: bannerList } = useSuspenseQuery({
    ...UnauthQueryOptions['get:/wello/v2/allows/banner']({
      query: {
        contentsTypeCd: BANNER_CONTENTS_TYPE.HOMETOWN_TOP,
        entry,
      },
    }),
    select: (data) => data.context?.contents ?? [],
  });

  const randomIndex = Math.floor(Math.random() * bannerList.length);

  if (bannerList.length < 1) return undefined;

  return {
    appFileUrl: bannerList[randomIndex].appFileUrl,
    appLinkUrl: bannerList[randomIndex].appLinkUrl,
    buttonText: bannerList[randomIndex].buttonText,
    fileUrl: bannerList[randomIndex].fileUrl,
    linkUrl: bannerList[randomIndex].linkUrl,
    subtitle: bannerList[randomIndex].subtitle,
    targetNewYN: bannerList[randomIndex].targetNewYN,
    title: bannerList[randomIndex].title,
  };
};
